import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

// Fund Overview / About body: clamps to 4 lines and, only when the text
// actually overflows, adds a Read more → / Show less toggle (mirrors the
// 10K/8K Risks tab pattern).
export const ExpandableAboutText = ({ text, clamp = true, resetKey }) => {
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);

  useEffect(() => { setExpanded(false); }, [resetKey]);

  useLayoutEffect(() => {
    if (!clamp || expanded) return;
    const el = ref.current;
    if (!el) return;
    const check = () => setOverflows(el.scrollHeight > el.clientHeight + 1);
    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [clamp, expanded, text]);

  const clamped = clamp && !expanded;
  return (
    <>
      <p
        ref={ref}
        className={`text-xs font-bold text-muted-foreground leading-relaxed ${clamped ? 'line-clamp-4' : ''}`}
        data-testid="about-text"
      >
        {text}
      </p>
      {clamp && (overflows || expanded) && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="block mt-1 text-[11px] font-semibold text-primary hover:underline"
          data-testid="about-read-more-toggle"
        >
          {expanded ? 'Show less' : 'Read more →'}
        </button>
      )}
    </>
  );
};
